import { WorkawareApi } from 'apis/WorkawareApi'

const POLICY_CATEGORY_TYPE = 29


export class policiesService {
    private _api: WorkawareApi

    constructor(api: WorkawareApi) {
        this._api = api
    }

    getPolicyCategories = async (): Promise<any[]> => {
        const result = await this._api.picklistItems.getByType(POLICY_CATEGORY_TYPE)
        const items: any[] = result.value || result
        if (items.length === 0) {
            await this._api.picklistItems.reset(POLICY_CATEGORY_TYPE)
            const seeded = await this._api.picklistItems.getByType(POLICY_CATEGORY_TYPE)
            return seeded.value || seeded
        }
        return items
    }

    createPolicyCategory = (data: any) => {
        return this._api.picklistItems.create({ ...data, Type: POLICY_CATEGORY_TYPE, IsActive: true })
    }

    updateCategory = (categoryId: number, value: string) => {
        return this._api.picklistItems.update(categoryId, { Value: value })
    }

    deleteCategory = (categoryId: number) => {
        return this._api.picklistItems.delete(categoryId)
    }

    getPolicies = () => {
        return new Promise<any>((resolve, reject) => {
            this._api.companyPolicies
                .getAll()
                .then((result) => {
                    const policies = result.value ? result.value : result
                    resolve(policies)
                })
                .catch((error) => reject(error))
        })
    }

    createPolicy = (policyData: any) => {
        return new Promise<any>((resolve, reject) => {
            this._api.companyPolicies
                .create(policyData)
                .then((result) => resolve(result))
                .catch((error) => reject(error))
        })
    }

    updatePolicy = (policyId: number, policyData: any) => {
        return new Promise<any>((resolve, reject) => {
            this._api.companyPolicies
                .update(policyId, policyData)
                .then((result) => resolve(result))
                .catch((error) => reject(error))
        })
    }

    deletePolicy = (policyId: number) => {
        return new Promise<any>((resolve, reject) => {
            this._api.companyPolicies
                .delete(policyId)
                .then((result) => resolve(result))
                .catch((error) => reject(error))
        })
    }
}
